// extracted by mini-css-extract-plugin
export default {"image":"CompanyPicture_image__LU5Is"};